var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-grid kt-grid--ver kt-grid--root"},[_c('div',{staticClass:"kt-grid__item kt-grid__item--fluid kt-grid kt-error-v2",style:({
      backgroundImage: `url(${_vm.backgroundImage})`,
    })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-error_container"},[_c('span',{staticClass:"kt-error_title2 kt-font-light"},[_c('h1',[_vm._v("OOPS!")])]),_c('span',{staticClass:"kt-error_desc kt-font-light"},[_vm._v(" Something went wrong here ")])])
}]

export { render, staticRenderFns }